import type { SchemaDiagnostic } from "../../shared/api/client";
import type { CompiledManifest } from "../../shared/api/generated/contracts";
import { useT } from "../../shared/i18n";
import { Banner, Card } from "../../shared/ui";
import { ChangeTile } from "./ChangeTile";
import { describeChange } from "./controls";

/** Publishing would break stored data: the warning and the parts it breaks. */
export function BlockedChanges({
  changes,
  manifests,
}: {
  changes: readonly SchemaDiagnostic[];
  manifests: (CompiledManifest | undefined)[];
}) {
  const t = useT();
  return (
    <section className="flex flex-col gap-3.5">
      <Banner tone="warning" title={t("draft.incompatible.title")}>
        {t("draft.incompatible.body")}
      </Banner>
      <Card flush>
        <ul>
          {changes.map((change) => {
            const { key, subject } = describeChange(change, manifests);
            return (
              <li
                key={change.path + change.code}
                className="flex items-center gap-3 border-b border-line-subtle px-4 py-2.5 text-body last:border-b-0"
              >
                <ChangeTile kind="blocked" />
                <span className="min-w-0 flex-1">
                  {t(key)} «{subject}»
                </span>
              </li>
            );
          })}
        </ul>
      </Card>
    </section>
  );
}
